import { isEmpty } from 'lodash';
import Cookies from 'universal-cookie';

const checkIsChangeDevice = (monitoringStatus) => {
  const cookies = new Cookies();

  const deviceId = cookies.get('deviceId');

  if (isEmpty(monitoringStatus?.presence?.deviceId)) return false;

  return monitoringStatus?.presence?.deviceId !== deviceId && (monitoringStatus?.status === 'CLOCKED_IN_ACTIVE' || monitoringStatus?.status === 'ON_BREAK');
};

export default checkIsChangeDevice;
